module.exports = __webpack_public_path__ + "img/arbre_5_ombre.c4491141.png";